export default [
  '请点击顶部导航栏中的^{联系我们}，选择~{购买咨询}{inquiry}，填写您的购买需求。我们的商务会及时联系您，和您确认您的需求。',
  '签订API服务购买合同后，您需要在我们的API平台注册账号。登录API平台后，您可以点击^{应用管理}，选择^{我的服务}，查看您购买的服务详情。',
  '调用 API服务前，需要先创建一个密钥，它是使用 API的凭证。登录API平台后，您可以点击^{应用管理}，选择^{密钥管理}。在^{密钥管理}页面为您购买的API服务创建新的密钥。密钥由 accesskey id 和 secret 组成，请妥善保存密钥信息。如果不慎泄漏或者遗忘密钥，可以选择停用此密钥，再创建一个新的密钥。',
  '创建完密钥后，您可以根据~{API文档}{apiDocument}的对应说明，开始使用我们的API服务了。',
];
